export default __webpack_public_path__ + "static/daze-days-logo-artwork-9e72bcd92b587f01acb02a272486470b.png";